module.exports = __webpack_public_path__ + "img/L_KC.d012c562.png";